// extracted by mini-css-extract-plugin
export default {"formWrapper":"form_formWrapper__hDgG6","actions":"form_actions__+LS9n","tableWrapper":"form_tableWrapper__yEhlD"};